<template>
  <v-row
    justify="center"
    :class="{ invisible: !isDialoglVisible }"
  >
    <v-dialog
      v-model="isDialoglVisible"
      persistent
      max-width="512"
    >
      <v-card>
        <v-card-title class="headline">
          <span>{{ $i18n.t('dialog.header.addingComment') }}</span>
        </v-card-title>
        <v-form
          ref="form"
          v-model="isValid"
          @submit.prevent="save"
          id="form--comment"
        >
          <v-card-text>
            <template>
              <v-text-field
                outlined
                v-model="comment"
                :rules="rules"
                :label="$i18n.t('offer.comments.table.content')"
                required
              />
            </template>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn
              color="primary"
              text
              @click="close"
            >{{ $i18n.t('dialog.confirmation.close') }}</v-btn>
            <v-btn
              :disabled="!isValid"
              color="primary"
              text
              :title="$i18n.t('dialog.confirmation.save')"
              type="submit"
              form="form--comment"
            >{{ $i18n.t('dialog.confirmation.save') }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'AddCommentDialog',
  data: () => ({
    comment: '',
    isValid: false,
    isDialoglVisible: false
  }),
  props: {
    entityId: {
      required: true,
      type: [String, Number]
    }
  },
  computed: {
    rules() {
      return [v => !!v || this.$i18n.t('default.ruleNoEmpty')];
    },
    user() {
      return this.$store.getters.getUser;
    }
  },
  methods: {
    close() {
      this.isDialoglVisible = false;
      this.$refs.form.reset();
    },
    save() {
      if (this.$refs.form.validate()) {
        const payload = {};
        const timeStamp = new Date();

        payload.content = this.comment;
        payload.restrictions = 'admin-panel';
        payload.entity_type = this.entityType;
        payload.entity_id = this.entityId;
        this.$store.dispatch('postComment', payload).then(r => {
          if (r.status === 200 || r.status === 201) {
            const self = this;
            this.$root.$emit(
              'showSnackbar',
              self.$i18n.t('offer.comments.addSucc')
            );
            this.$emit('addedItem', {
              id: r.data.comments,
              content: this.comment,
              entity_type: this.entityType,
              entity_id: this.entityId,
              created_at: timeStamp,
              updated_at: null,
              user: this.user,
              restrictions: 'admin-panel'
            });
            this.close();
          } else if (r.status >= 400) {
            this.$root.$emit(
              'showSnackbar',
              this.$i18n.t('offer.comments.addError')
            );
          }
        });
      }
    },
    saveLastContact() {
      const timeStamp = new Date();
      const contactComment = `Ostatni kontakt: ${timeStamp.toLocaleString(
        'pl-PL',
        {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        }
      )}`;
      const payload = {
        content: contactComment,
        restrictions: 'admin-panel',
        entity_type: this.entityType,
        entity_id: this.entityId
      };
      this.$store.dispatch('postComment', payload).then(r => {
        if (r.status === 200 || r.status === 201) {
          const self = this;
          this.$root.$emit(
            'showSnackbar',
            self.$i18n.t('offer.comments.addContact')
          );
          this.$emit('addedItem', {
            id: r.data.comments,
            content: contactComment,
            entity_type: this.entityType,
            entity_id: this.entityId,
            created_at: timeStamp,
            updated_at: null,
            user: this.user,
            restrictions: 'admin-panel'
          });
        } else if (r.status >= 400) {
          this.$root.$emit(
            'showSnackbar',
            this.$i18n.t('offer.comments.addError')
          );
        }
      });
    },
    openDialog() {
      this.isDialoglVisible = true;
    }
  },
  beforeMount() {
    this.entityType = this.$options.parent.$props.entityType;
  },
  mounted() {
    this.$root.$on('openCommentsDialog', this.openDialog);
    this.$root.$off('addLastContactComment');
    this.$root.$on('addLastContactComment', this.saveLastContact);
  }
};
</script>

<style>
.invisible {
  display: none;
}
</style>
